import { useCallback, useContext, useEffect } from 'react';
import { useEditContext } from 'react-admin';

import { AppContext } from '@app/contexts';
import { useLogoImage } from '@app/hooks/useLogoImage';
import { FIELD_TYPES, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import EditView from '@app/components/common/views/EditView';

import { SeriesForm } from './SeriesForm';

const requiredFields = [
  { key: 'name', type: FIELD_TYPES.MULTILINGUAL, message: 'Name is required' },
  { key: 'short_description', type: FIELD_TYPES.MULTILINGUAL, message: 'Short description is required' },
  { key: 'about', type: FIELD_TYPES.MULTILINGUAL, message: 'About field is required' },
];

const nonRequiredFields = [
  { key: 'schedule', emptyValue: '', isMultilingual: true },
  { key: 'focused_topic_ids', emptyValue: [] },
  { key: 'regular_expert_ids', emptyValue: [] },
];

export const EditSeries = () => {
  const { handleChangeLoading } = useContext(AppContext);
  const { saving } = useEditContext();

  const { logoImage, handleChangeImageLogo, transform } = useLogoImage(nonRequiredFields);

  useEffect(() => {
    handleChangeLoading(!!saving);
  }, [saving, handleChangeLoading]);

  const validate = useCallback(
    (values: GenericObject) => validateFormFields({ fields: requiredFields, values, image: logoImage }),
    [logoImage]
  );

  return (
    <div>
      <EditView resourceSingular="series" validate={validate} transform={transform} mutationMode="pessimistic">
        <SeriesForm
          seriesThumbnail={logoImage}
          title="EDIT SERIES"
          handleChangeSeriesThumbnail={handleChangeImageLogo}
        />
      </EditView>
    </div>
  );
};
